import axios from 'axios'



export const updateList = data => {
    return {
        type: 'USER_NOTIFICATION_LIST',
        payload: data
    }
}

export const unread = number => {
    return {
        type: 'USER_NOTIFICATION_UNREAD',
        payload: number
    }
}

export const unreadAdd = number => {
    return {
        type: 'USER_NOTIFICATION_UNREAD_ADD',
        payload: number
    }
}

export const lastIn = registers => {
    return {
        type: 'USER_NOTIFICATION_LAST',
        payload: registers
    }
}

export const getNotifications = (startIn = 0) => {
    return dispatch => {
        var limit = 20
        axios.get('notification/list_all/unread/'+startIn+'/'+limit)
        .then(response => {
                if(!response.result) return

                var sizeof = response.result.length
                if(sizeof > 0) {
                    var last = startIn + sizeof
                    dispatch(unreadAdd(sizeof))
                    dispatch(updateList(response.result))
                    dispatch(lastIn(last))
                }
            })
    }
}

export const markToRead = id => {
    return (dispatch, store) => {
        var index = null
        var msg = store().userNotification.list.find(function(item, i) {
            if(item.id === id) {
                index = i
                return true
            }
            return false
        })
        
        if(msg) {
            if(msg.status === 'send') {
                axios.get('notification/mark_read/'+msg.id)
                dispatch({
                    type: 'USER_NOTIFICATION_READED',
                    payload: index
                })
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/modules/actions/Notification.js